import header from './_header';
import smoothScroll from './_smoothScroll';
import animation from './_animation';

const common = (): void => {
  // header
  header();
  // smooth scroll
  smoothScroll();
  // animation
  animation();
};

export default common;
